export default __webpack_public_path__ + "static/hand-shake-38a616831599d8835a9f3dee75567dfa.png";